// @ts-strict-ignore
import { SetStateAction } from 'react'
import { logSentryErrorAndGetEventId } from '@node-space/utils'
import { BaseErrorResponse } from 'types/beneficiaries'
import { MappedErrorMessageState } from 'types/errors'

export const handleOnMutationError = (
  error: BaseErrorResponse,
  data: unknown,
  setRequestError: (value: SetStateAction<MappedErrorMessageState>) => void,
  requestUrl: string,
  requestName: string,
  handleErrorList: boolean = false
) => {
  const errorStatus = error?.status
  let sentryEventId = null

  if (errorStatus !== 400) {
    sentryEventId = logSentryErrorAndGetEventId(
      `Failed API request to ${requestUrl} with status ${error?.status} - ${requestName}`,
      error,
      {
        data: typeof data === 'string' ? { message: data } : data,
      }
    )
  }

  const errorMessage = error?.data?.message || error?.message
  const errorList = error?.data?.errorList

  if (errorList?.length && handleErrorList) {
    setRequestError({
      handledMessage: errorList[0]?.message,
      sentryTraceId: sentryEventId,
      show: true,
    })
  } else {
    setRequestError({
      handledMessage: errorMessage,
      errorCode: error?.status,
      sentryTraceId: sentryEventId,
      show: true,
    })
  }
}
